import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ProcessStep } from "shared";

type UpdateExcludedProcessStepsResponse = ClientInferResponseBody<
  typeof contract.cluster.updateExcludedProcessSteps
>;

export const updateExcludedProcessSteps = async ({
  clusterId,
  excludedProcessSteps,
}: {
  clusterId: string;
  excludedProcessSteps: ProcessStep[];
}): Promise<UpdateExcludedProcessStepsResponse | null> => {
  const response = await api.cluster.updateExcludedProcessSteps.mutation({
    body: { excludedProcessSteps: excludedProcessSteps.map((p) => p.id) },
    params: {
      id: clusterId,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
